import React from 'react'
import { responsiveMedia } from "../../services/media";
// import { Modal} from "../../modelsTesting"
// import { Input } from "../../modelsTesting"
// import { Modal, Input } from "@iq/models"
import { Input, RubberSegment } from "../../modelsTesting"
import { LuSave } from "react-icons/lu"
import "./createProductModalStyles.css"
import { IoMdArrowBack } from "react-icons/io";
import SimpleVariant from "./SimpleVariant";
import VariantMatrix from "./VariantMatrix";
import { GoImage } from "react-icons/go";
import { IoMdTrash } from "react-icons/io";
import { Modal2 } from "@iq/models"

export default function CreateVariantModal({
    isOpen,
    onBack,
    onClose,
    onSave = () => {},
    productName,
    productDescription = "",
    attributes = [],
    variants = [],
    onAttributesChange = () => {},
    onVariantsChange = () => {},
    animateIn = false,
    animateOut = true,
}) {

    const [ variantModalType, setVariantModalType ] = React.useState("simple");
    const [ matrixStep, setMatrixStep ] = React.useState(0);
    const [ selectedVariantSku, setSelectedVariantSku ] = React.useState("");
    const [ isSavingProduct, setIsSavingProduct ] = React.useState(false);
    const [ errorMessage, setErrorMessage ] = React.useState("");
    const normalizedAttributes = React.useMemo(() => {
        if (!Array.isArray(attributes)) {
            return [];
        }

        return attributes
            .map((attribute) => {
                const label = String(attribute?.Name || attribute?.name || attribute || "").trim();
                return label;
            })
            .filter(Boolean);
    }, [attributes]);
    const normalizedVariants = React.useMemo(() => Array.isArray(variants) ? variants : [], [variants]);
    const selectedVariant = React.useMemo(() => normalizedVariants.find((existingVariant) => (
        String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase() === selectedVariantSku
    )) || null, [normalizedVariants, selectedVariantSku]);

    React.useEffect(() => {
        console.log("🟣 CreateVariantModal isOpen:", isOpen, "variants:", variants);
    }, [isOpen, variants]);

    React.useEffect(() => {
        if (!selectedVariantSku) {
            return;
        }

        const stillExists = normalizedVariants.some((existingVariant) => (
            String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase() === selectedVariantSku
        ));

        if (!stillExists) {
            setSelectedVariantSku("");
        }
    }, [normalizedVariants, selectedVariantSku]);

    React.useEffect(() => {
        if (variantModalType !== "matrix") {
            setMatrixStep(0);
        }
    }, [variantModalType]);

    const handleAttributesChange = React.useCallback((nextValues) => {
        const normalizedValues = Array.isArray(nextValues) ? nextValues : [];
        onAttributesChange?.(normalizedValues);
    }, [onAttributesChange]);

    const handleSaveVariant = React.useCallback((newVariant) => {
        const normalizedSku = String(newVariant?.SKU || newVariant?.sku || "").trim().toLowerCase();
        const isEditing = Boolean(selectedVariantSku);

        if (isEditing) {
            const conflictsWithAnotherVariant = normalizedVariants.some((existingVariant) => {
                const existingSku = String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase();
                return existingSku === normalizedSku && existingSku !== selectedVariantSku;
            });

            if (conflictsWithAnotherVariant) {
                return;
            }

            const nextVariants = normalizedVariants.map((existingVariant) => {
                const existingSku = String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase();
                if (existingSku === selectedVariantSku) {
                    return newVariant;
                }

                return existingVariant;
            });

            onVariantsChange?.(nextVariants);
            setSelectedVariantSku("");
            return;
        }

        const alreadyExists = normalizedVariants.some((existingVariant) => (
            String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase() === normalizedSku
        ));

        if (alreadyExists) {
            return;
        }

        const nextVariants = [...normalizedVariants, newVariant];
        onVariantsChange?.(nextVariants);
    }, [normalizedVariants, onVariantsChange, selectedVariantSku]);

    const handleSaveVariantMatrix = React.useCallback((selectedMatrixVariants) => {
        const normalizedMatrixVariants = Array.isArray(selectedMatrixVariants)
            ? selectedMatrixVariants
            : [];

        if (normalizedMatrixVariants.length === 0) {
            return;
        }

        const existingVariantBySku = new Map(
            normalizedVariants.map((existingVariant) => [
                String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase(),
                existingVariant,
            ])
        );

        normalizedMatrixVariants.forEach((nextVariant) => {
            const normalizedSku = String(nextVariant?.SKU || nextVariant?.sku || "").trim().toLowerCase();

            if (!normalizedSku) {
                return;
            }

            existingVariantBySku.set(normalizedSku, nextVariant);
        });

        onVariantsChange?.(Array.from(existingVariantBySku.values()));
    }, [normalizedVariants, onVariantsChange]);

    const handleDeleteVariant = React.useCallback((skuToDelete) => {
        const normalizedSkuToDelete = String(skuToDelete || "").trim().toLowerCase();
        const nextVariants = normalizedVariants.filter((existingVariant) => (
            String(existingVariant?.SKU || existingVariant?.sku || "").trim().toLowerCase() !== normalizedSkuToDelete
        ));
        if (normalizedSkuToDelete === selectedVariantSku) {
            setSelectedVariantSku("");
        }
        onVariantsChange?.(nextVariants);
    }, [normalizedVariants, onVariantsChange, selectedVariantSku]);

    const handleCancelEdit = React.useCallback(() => {
        setSelectedVariantSku("");
    }, []);

    const handleSaveProduct = React.useCallback(async () => {
        console.log("🔴 handleSaveProduct clicked");
        console.log("productName:", productName);
        console.log("productDescription:", productDescription);
        console.log("normalizedVariants:", normalizedVariants);
        
        if (!String(productName || "").trim()) {
            console.warn("❌ Product name is empty");
            setErrorMessage("Product name is required.");
            return;
        }

        if (!String(productDescription || "").trim()) {
            console.warn("❌ Product description is empty");
            setErrorMessage("Product description is required.");
            return;
        }

        if (normalizedVariants.length === 0) {
            console.warn("❌ No variants");
            setErrorMessage("Please add at least one variant.");
            return;
        }

        setIsSavingProduct(true);
        setErrorMessage("");

        try {
            console.log("🟡 Calling onSave with variants:", normalizedVariants);
            await onSave?.(normalizedVariants);
            console.log("✅ onSave completed successfully");
        } catch (error) {
            console.error("❌ onSave error:", error);
            setErrorMessage(error?.message || "Failed to save product.");
        } finally {
            setIsSavingProduct(false);
        }
    }, [normalizedVariants, onSave, productDescription, productName]);

    const actionButtons = React.useMemo(() => ([
        
        {
            key: "back",
            text: "Back",
            icon: <IoMdArrowBack size={16} />,
            style: {
                backgroundColor: "var(--surface-2)",
                color: "var(--fg-default)",
                border: "1px solid var(--border-default)",
            },
            onClick: onBack,
            disabled: isSavingProduct,
        },
        {
            key: "save-product",
            text: isSavingProduct ? "Saving..." : "Save Product",
            icon: <LuSave size={16} />,
            onClick: handleSaveProduct,
            disabled: isSavingProduct || normalizedVariants.length === 0 || !String(productName || "").trim() || !String(productDescription || "").trim(),
        },
        
    ]), [handleSaveProduct, isSavingProduct, normalizedVariants, onBack, productDescription, productName]);
    return (
        <Modal2
            isOpen={isOpen}
            onClose={onClose}
            title="Create Product Variants"
            styles={{
                panel: {
                    height: "clamp(420px, 90vh, 980px)",
                    width: "fit-content",
                },
            }}
            actionButtons={actionButtons}
            errorMessage={errorMessage}
            // animateIn={animateIn}
            animateIn
            // animateOut={animateOut}
            animateOut
        >
            <div className={`createVariantModalContainer${variantModalType === "matrix" && matrixStep === 2 ? " createVariantModalContainerMatrixStepReview" : ""}`}>
                <div className="createVariantModalDetailsContainer">
                    <Input
                        label="Product Name"
                        value={productName}
                        readOnly={true}
                    />
                    {/* <Input 
                        label="Attributes"
                        type="addItem"
                        onItemsChange={handleAttributesChange}
                        initialItems={normalizedAttributes}
                        placeholder="Ex: Color, Size, Material"
                    /> */}
                    <div className="createVariantModalVariantsContainer">
                        <div className="createVariantModalVariantsHeader">Variants</div>
                        <div className="createVariantModalVariantsScrollList">
                            {normalizedVariants.length > 0 ? normalizedVariants.map((variant) => (
                                (() => {
                                    const firstImage = Array.isArray(variant.Images)
                                        ? variant.Images[0]
                                        : Array.isArray(variant.images)
                                            ? variant.images[0]
                                            : null;
                                    const imageUrl = typeof firstImage === "string"
                                        ? String(firstImage || "").trim()
                                        : String(
                                            firstImage?.URL
                                            || firstImage?.url
                                            || firstImage?.Src
                                            || firstImage?.src
                                            || firstImage?.ImageURL
                                            || firstImage?.image_url
                                            || ""
                                        ).trim();

                                    return (
                                <div
                                    role="button"
                                    tabIndex={0}
                                    key={variant.SKU || variant.sku}
                                    className={`createVariantModalVariantCard${String(variant.SKU || variant.sku || "").trim().toLowerCase() === selectedVariantSku ? " createVariantModalVariantCardSelected" : ""}`}
                                    onClick={() => {
                                        setSelectedVariantSku(String(variant.SKU || variant.sku || "").trim().toLowerCase());
                                        setVariantModalType("simple")
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter" || event.key === " ") {
                                            event.preventDefault();
                                            setSelectedVariantSku(String(variant.SKU || variant.sku || "").trim().toLowerCase());
                                            setVariantModalType("simple");
                                        }
                                    }}
                                >
                                    <div className="createVariantModalVariantCardImageContainer">
                                        {imageUrl ? (
                                            <img 
                                                {...responsiveMedia(imageUrl, "240px")}
                                                loading="lazy"
                                                decoding="async"
                                                alt={`Variant ${variant.SKU || variant.sku || "image"}`}
                                            />
                                        ) : (

                                            <GoImage size={48} color="var(--surface-soft)" />
                                        )}
                                    </div>
                                    <div className="createVariantModalVariantCardDetailsContainer">
                                        <div className="createVariantModalVariantCardHeader">
                                            <p className="createVariantModalVariantCardHeaderSKU">{variant.SKU || variant.sku}</p>
                                            <button
                                                type="button"
                                                className="createVariantModalDeleteVariantButton"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleDeleteVariant(variant.SKU || variant.sku);
                                                }}
                                            >
                                                <IoMdTrash size={18} />
                                            </button>
                                        </div>
                                        <div className="createVariantModalVariantCardMetaContainer">
                                            <div className="createVariantModalVariantCardMeta"><span>Cost: </span>${(Number(variant.Cost || 0) / 100).toFixed(2)}</div>
                                            <div className="createVariantModalVariantCardMeta"><span>Stock: </span>{variant.Stock || 0}</div>
                                            <div className="createVariantModalVariantCardMeta"><span>Weight: </span>{variant.Weight || 0} lbs</div>
                                        </div>
                                    </div>
                                </div>
                                    );
                                })()
                            )) : (
                                <p className="createVariantModalEmptyState">No variants added yet.</p>
                            )}
                        </div>
                    </div>
                </div>
                <div className="createVariantModalNewVariantContainer">
                    <RubberSegment
                        items={[
                            { value: "simple", label: "Simple Variant" },
                            { value: "matrix", label: "Variant Matrix" },
                        ]}
                        value={variantModalType}
                        onChange={setVariantModalType}
                        aria-label="Variant creation type"
                        className="createVariantModalTypeToggle"
                        trackColor="var(--surface-1)"
                        thumbColor="var(--surface-soft)"
                        textColor="var(--fg-muted)"
                        activeTextColor="var(--fg-default)"
                        radius={12}
                        size="lg"
                    />
                    {variantModalType === "simple" && normalizedAttributes.length != 0 && (
                        <SimpleVariant
                            attributes={normalizedAttributes}
                            productName={productName}
                            onSaveVariant={handleSaveVariant}
                            editingVariant={selectedVariant}
                            isEditing={Boolean(selectedVariant)}
                            onCancelEdit={handleCancelEdit}
                        />
                    )}
                    {variantModalType === "matrix" && normalizedAttributes.length != 0 && (
                        <VariantMatrix
                            attributes={normalizedAttributes}
                            productName={productName}
                            onStepChange={setMatrixStep}
                            onSaveVariantMatrix={handleSaveVariantMatrix}

                        />
                    )}
                    { normalizedAttributes.length === 0 && (
                        <p className="createVariantModalEmptyState">Add at least one attribute to create variants.</p>
                    )}
                </div>


            </div>
        </Modal2>
    )
}
